import { useContext } from 'react';

import { ViewingContext, type ViewingContextValue } from './viewing-context';

/** Which organization staff are viewing, and how to start and stop. */
export function useViewingAs(): ViewingContextValue {
  const context = useContext(ViewingContext);
  if (!context) {
    throw new Error('useViewingAs must be used inside <ViewingAsProvider>.');
  }
  return context;
}

/**
 * True when nothing on the page may be changed because staff are viewing it.
 *
 * The one question an organization page asks. It says nothing about the
 * organization's own status, which each page still checks for itself - a page
 * can be read-only for both reasons at once.
 */
export function useReadOnly(): boolean {
  return useViewingAs().viewing !== null;
}
